import { Flex, Text } from "@chakra-ui/react";
import { WriteLeftDotLine } from "../../ComponentLayouter/WriteLeftDotLine";
import { AddMarginLeft } from "../../ComponentLayouter/AddMarginLeft";
import { DurationDistance } from "~/generated/graphql.types";

export const SpotStatEntity = ({
  stat,
  dataTestId,
  hasLeftMargin,
}: {
  stat: DurationDistance;
  dataTestId?: string;
  hasLeftMargin: boolean;
}) => {
  const Wrapper = hasLeftMargin ? AddMarginLeft : WriteLeftDotLine;
  return (
    <Wrapper>
      <Flex alignItems="baseline" mt={0} data-testid="spot-stat">
        <>
          <Text as="b">{(stat.distance / 1000).toFixed(2)}</Text>
          <Text ml={1} fontSize="xs">
            km
          </Text>
          <Text ml={2} as="b">
            {(stat.duration / 60).toFixed(1)}
          </Text>
          <Text ml={1} fontSize="xs">
            分
          </Text>
        </>
      </Flex>
    </Wrapper>
  );
};
